import { useTranslation } from 'react-i18next';

import { AdminRoutePath } from 'applications/GSP/shared/constants/router';

import { useSchoolLinksRouteConfig } from './hooks';

import type { RouteObject } from 'shared/types';

export const useAdminRoutesConfig = (): RouteObject[] => {
  const { t } = useTranslation();
  // TODO: implement general solution to show routes according to featureFlags
  const schoolLinksRouteConfig = useSchoolLinksRouteConfig();

  return [
    {
      path: AdminRoutePath.StudentObserver,
      handle: {
        crumb: t('GSP.layouts.mainLayout.header.breadcrumbs.studentObserver'),
      },
      lazy: () =>
        import('applications/GSP/pages/StudentObserver').then(
          ({ StudentObserver }) => ({
            Component: StudentObserver,
          }),
        ),
    },
    ...schoolLinksRouteConfig,
    {
      path: AdminRoutePath.SchoolLinksManager,
      handle: {
        crumb: t(
          'GSP.layouts.mainLayout.header.breadcrumbs.schoolLinksManager',
        ),
      },
      lazy: () =>
        import('applications/GSP/pages/SchoolLinksManager').then(
          ({ SchoolLinksManager }) => ({
            Component: SchoolLinksManager,
          }),
        ),
    },
  ];
};
